type UncapitalizeObjectKeys<T extends object> = {
  [key in UncapitalizeKeys<T>]: Capitalize<key> extends keyof T ? T[Capitalize<key>] : never;
};

type UncapitalizeKeys<T extends object> = Uncapitalize<keyof T & string>;

export const lowerCaseKeys = <T extends object>(obj: T): any => {
  if (typeof obj !== 'object' || !obj) {
    return obj as UncapitalizeObjectKeys<T>;
  }

  if (Array.isArray(obj) && obj.length) {
    var mappedArr = obj.map(lowerCaseKeys);

    return mappedArr;
  }

  const entries = Object.entries(obj);

  const mappedEntries = entries.map(([k, v]) => {
    return [`${k.substr(0, 1).toLowerCase()}${k.substr(1)}`, lowerCaseKeys(v)];
  });

  return Object.fromEntries(mappedEntries) as UncapitalizeObjectKeys<T>;
};
